export default {"src":"/_next/static/image/public/images/icons2/1.653e2b2bac26d8bfd0cdf8c08a827c67.svg","height":24,"width":24};